import { createAction, props } from '@ngrx/store';

export const NameApifonChange = createAction(
  '[APIFON CONFIGURATION]: Name Apifon Changed',
  props<{ nameApifon: string }>(),
);

export const StatusApifonChange = createAction(
  '[APIFON CONFIGURATION]: Status Apifon Changed',
  props<{ statusApifon: boolean }>(),
);

export const ConfigurationTypeApifonChange = createAction(
  '[APIFON CONFIGURATION]: ConfigurationApifon Type Apifon Changed',
  props<{ configurationTypeApifon: string }>(),
);

export const SmsSenderApifonChange = createAction(
  '[APIFON CONFIGURATION]:  SMS Sender Apifon Changed',
  props<{ smsSenderApifon: string }>(),
);

export const ViberSenderApifonChange = createAction(
  '[APIFON CONFIGURATION]:  VIBER Sender Apifon Changed',
  props<{ viberSenderApifon: string }>(),
);

export const TokenApifonChange = createAction(
  '[APIFON CONFIGURATION]: Token Apifon Changed',
  props<{ tokenApifon: string }>(),
);

export const ApiKeyApifonChange = createAction(
  '[APIFON CONFIGURATION]: API Key Apifon Changed',
  props<{ apiKeyApifon: string }>(),
);

export const SaveApifonConfiguration = createAction('[APIFON CONFIGURATION]: Save Apifon Configuration');

export const SaveApifonConfigurationSuccess = createAction(
  '[APIFON CONFIGURATION]: Save Apifon Configuration Success',
  props<{ res: any }>(),
);

export const SaveApifonConfigurationFailed = createAction(
  '[APIFON CONFIGURATION]: Save Apifon Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateApifonConfiguration = createAction('[APIFON CONFIGURATION]: Update APIFON CONFIGURATION');

export const UpdateApifonConfigurationSuccess = createAction(
  '[APIFON CONFIGURATION]: Update Apifon Configuration Success',
  props<{ res: any }>(),
);

export const UpdateApifonConfigurationFailed = createAction(
  '[APIFON CONFIGURATION]: Update Apifon Configuration Failed',
  props<{ error: any }>(),
);

export const ToggleIntegrationConfHelpTextStatus = createAction(
  '[APIFON CONFIGURATION]: Toggle Integration Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[APIFON CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const ToggleCampaignReportingHelpTextStatus = createAction(
  '[APIFON CONFIGURATION]: Toggle Campaign Reporting Help Text Status',
);

export const LookBackDaysApifonChange = createAction(
  '[APIFON CONFIGURATION]: Look Back Days Apifon Changed',
  props<{ lookBackDaysApifon: number | null }>(),
);

export const EditApifonIntegrationSystem = createAction(
  '[APIFON CONFIGURATION]: Edit Apifon Integration System',
  props<{ apifonData: any }>(),
);

export const CloseApifonEditIntegration = createAction('[APIFON CONFIGURATION]:   Close Apifon Edit Integration');

export const ApifonSubmitData = createAction('[APIFON CONFIGURATION]: Apifon Submit Data');
